import { InsuranceType, Address, PersonalInfo } from "./types";
import InsuranceTypeStep from "./InsuranceTypeStep";
import AddressStep from "./AddressStep";
import PersonalInfoStep from "./PersonalInfoStep";
import ContactInfoStep from "./ContactInfoStep";

interface FormStepsProps {
  step: number;
  selectedType: InsuranceType | "";
  address: Address;
  personalInfo: PersonalInfo;
  onTypeChange: (value: InsuranceType) => void;
  onAddressChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onPersonalInfoChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onStepComplete: () => void;
}

const FormSteps = ({
  step,
  selectedType,
  address,
  personalInfo,
  onTypeChange,
  onAddressChange,
  onPersonalInfoChange,
  onStepComplete,
}: FormStepsProps) => {
  switch (step) {
    case 1:
      return (
        <InsuranceTypeStep
          selectedType={selectedType}
          onTypeChange={onTypeChange}
          onComplete={onStepComplete}
        />
      );
    case 2:
      return (
        <AddressStep
          address={address}
          onAddressChange={onAddressChange}
        />
      );
    case 3:
      return (
        <PersonalInfoStep
          personalInfo={personalInfo}
          onPersonalInfoChange={onPersonalInfoChange}
        />
      );
    case 4:
      return (
        <ContactInfoStep
          personalInfo={personalInfo}
          onPersonalInfoChange={onPersonalInfoChange}
        />
      );
    default:
      return null;
  }
};

export default FormSteps;